export const PHONE_LOADING = 'PHONE_LOADING'
export const PHONE_SUCCESS = 'PHONE_SUCCESS'
export const PHONE_ERROR = 'PHONE_ERROR'
export const SET_PHONE = 'SET_PHONE'
